import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface ICategoryNamePropertyEditable {
  categoryName(): IPropertyEditable<string>;
}

export function instanceOfICategoryNamePropertyEditable(instance: any): instance is ICategoryNamePropertyEditable {
  return instance
      && instance.categoryName
      && instanceOfIPropertyEditable<string>(instance.categoryName());
}
